// Зеркало `api/src/core/services/article_style.py` (PRD #60): api принимает ТОЛЬКО hex и
// градиенты из hex, иначе `422 invalid_style_value`. Регэкспы сверять с питоновскими.
const HEX = '#(?:[0-9a-fA-F]{8}|[0-9a-fA-F]{6}|[0-9a-fA-F]{3})'
const PCT = '-?\\d{1,3}(?:\\.\\d+)?%'
const STOP = `${HEX}\\s+${PCT}`

const COLOR = new RegExp(`^${HEX}$`)
const LINEAR = new RegExp(
  `^linear-gradient\\(\\s*-?\\d{1,3}(?:\\.\\d+)?deg\\s*(?:,\\s*${STOP}\\s*){2,5}\\)$`,
)
const RADIAL = new RegExp(`^radial-gradient\\(\\s*${STOP}\\s*(?:,\\s*${STOP}\\s*){1,4}\\)$`)

export const isArticleColor = (v: string): boolean => COLOR.test(v)

export const isArticleGradient = (v: string): boolean => LINEAR.test(v) || RADIAL.test(v)
